module.exports = __webpack_public_path__ + "media/images/fb_index_image-0c195f7932a15af0e22f423ca3ce4666.png";